import React, { useState, useEffect } from "react";
import "../approvemodal/style.css";
import MultiSelectDropdown from "../multiselectDropdown";
import { API_ENDPOINTS } from "../../constants/apiEndpoints";
import { get } from "../../config/api";
import { useSelector, useDispatch } from "react-redux";
import { showError } from "../../store/slices/formconfig";
import { Loader } from "../loader";

interface Props {
  show: boolean;
  onClose: () => void;
  onSubmit: (selectedDistributors: any[]) => void;
  preselectedDistributorIds: string[];
  partnerType?: string;
  unitCode?: string;
}

const DistributorMappingModal: React.FC<Props> = ({
  show,
  onClose,
  onSubmit,
  preselectedDistributorIds,
  partnerType,
  unitCode,
}) => {
  const [selectedDistributors, setSelectedDistributors] = useState<any[]>([]);
  const [mappedDistributors, setMappedDistributors] = useState<any[]>([]);
  const [isLoadingDistributors, setIsLoadingDistributors] = useState(false);
  const userData = useSelector((state: any) => state.formConfig.user);
  const dispatch = useDispatch();

  const fetchMappedDistributors = async () => {
    setIsLoadingDistributors(true);
    try {
      const response = await get(
        `${API_ENDPOINTS.MAPPED_DISTRIBUTORS(userData.userId)}`
      );

      response.map((element: any) => {
        element.id = element.partner_id;
      });

      setMappedDistributors(response);

      // Prepopulate selected distributors from preselectedDistributorIds
      if (preselectedDistributorIds && preselectedDistributorIds.length > 0) {
        const preselected = response.filter((d: any) =>
          preselectedDistributorIds.includes(d.id)
        );
        setSelectedDistributors(preselected);
      }
    } catch (error: any) {
      dispatch(
        showError({
          message:
            "Failed to fetch mapped distributors due to some technical issue, please try again later",
          visible: true,
        })
      );
      console.error("Failed to fetch mapped distributors:", error);
    } finally {
      setIsLoadingDistributors(false);
    }
  };

  useEffect(() => {
    if (show && skipDropdown) {
      // Skip fetching distributors for Distributor partner type or IN57 unit
      return;
    }
    if (show) {
      fetchMappedDistributors();
    }
  }, [show]);

  const isDistributor = partnerType?.toLowerCase() === "distributor";
  const isIN57 = unitCode === 'IN57';
  const skipDropdown = isDistributor || isIN57;

  if (!show) {
    return null;
  }

  const handleSubmit = () => {
    onSubmit(selectedDistributors);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container" style={{padding: 20}}>
        {isLoadingDistributors && <Loader />}
        <div className="modal-header">
          <span className="headerreject">Approve Certificate Request</span>
          <span className="close-button" onClick={onClose}>
            &times;
          </span>
        </div>
        <div className="modal-body">
          {!skipDropdown && (
            <div className="form-group">
              <label className="subhead">Distributor Mapping *</label>
              <MultiSelectDropdown
                options={mappedDistributors}
                selectedOptions={selectedDistributors}
                onChange={setSelectedDistributors}
                placeholder="Select distributor(s)"
              />
            </div>
          )}
          {skipDropdown && (
            <p style={{ margin: '10px 0', fontSize: 14, color: '#444' }}>Are you sure you want to approve this certificate request?</p>
          )}
        </div>
        <div className="modal-footer">
          <button
            className={
              skipDropdown || selectedDistributors.length > 0
                ? "approve-issue-button"
                : "approve-issue-button disabled"
            }
            onClick={handleSubmit}
            disabled={!skipDropdown && selectedDistributors.length === 0}
          >
            {skipDropdown ? 'Approve' : 'Approve and Forward'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DistributorMappingModal;
